// src/Components/SideBarNav/GenericSidebar.tsx
import React, { useState, useMemo } from 'react';
import { MENU_TREE } from 'acl/menuTree';
import { filterMenu } from 'acl/aclUtils';
import { IResourceNode } from 'acl/types';
import NavItem from './NavItem';
import UnreadMessagesCount from './UnreadMessagesCount';
import { useAuth } from 'utils/AuthProvider';
import './SideBarNav.css';

export default function GenericSidebar() {
  const { user, isClient } = useAuth();

  /* 🚩  HOOKS FIRST  ─────────────────────────────────── */
  const [open, setOpen] = useState<Record<string, boolean>>({});
  const menu = useMemo(() => filterMenu(MENU_TREE, user), [user]);

  /* 🔒  Preserve client view (sidebar hidden for clients) */
  if (isClient) return null;

  /* ────────── render helper ────────── */
  const render = (node: IResourceNode) => {
    const hasKids = !!node.children?.length;
    const expanded = open[node.key];

    return (
      <div key={node.key} className="custom-menu-item">
        <NavItem
          name={node.name}
          path={node.path ?? '#'}
          icon={node.icon}
          onClick={
            hasKids
              ? (e) => {
                  e.preventDefault();
                  setOpen((o) => ({ ...o, [node.key]: !o[node.key] }));
                }
              : undefined
          }
          showArrow={hasKids}
          isExpanded={expanded}
          isDropdownToggle={hasKids}
          suffix={node.key === 'messages' ? <UnreadMessagesCount /> : undefined}
        />
        {hasKids && expanded && (
          <div className="pl-4">{node.children!.map(render)}</div>
        )}
      </div>
    );
  };

  /* ────────── main JSX ────────── */
  return (
    <div className="custom-sidebar">
      <div className="custom-menu-items">
        <h2 className="custom-menu-heading">Main Menu</h2>
        <div className="separator" />
        {menu.map(render)}
      </div>
    </div>
  );
}
